import { getCurrentUser } from '@features/auth';
import { type LogLevel, type ILogger, type LogMessageParams, LogLevels } from '@types';
import { logger } from './loggerInstance';

type LoggerFn = NonNullable<ILogger['info']>;

function getLoggerFn (level: LogLevel, l: ILogger): LoggerFn {
  switch (level) {
  case 'info':    return l.info;
  case 'warning': return l.warning;
  case 'error':   return l.error;
  case 'success': return l.success ?? l.info;
  }
}

/**
 * Params:
 * <ul>
 *     <li>message: Overridden English translation of a key: t(settings.user.name, {lng: 'en'})</li>
 *     <li>source: function from where the log is called;</li>
 *     <li>context: Additional info in form of K:V format.</li>
 * </ul>
 * Sends a log to the logger with a determined level and adding source and extra context.
 */
export async function writeIntoLogs<T> ({
  message,
  level = LogLevels.WARNING,
  context = {},
  source,
}: LogMessageParams<T>): Promise<void> {
  const user = getCurrentUser();

  const meta = {
    source,
    context: {
      actor: { ...(user != null
        ? {
          userId: user.userId,
          email: user.email,
          userType: Array.isArray(user.type) ? user.type.join(', ') : undefined,
        }
        : {}) },
      ...context,
    },
  };

  const fn = getLoggerFn(level, logger);
  await fn(message, meta);
}

